import { createAxiosApi } from "@/shared/axios/axios";

export type ChatWidgetContactDto = {
    name?: string;
    contact?: string;
    comment?: string;
};

export type ChatWidgetVisitorDto = {
    pageUrl?: string;
    referrer?: string;
    userAgent?: string;
    language?: string;
    timezone?: string;
};

export type PostChatWidgetMessageDto = {
    sessionId: string;
    eventType: "message" | "lead";
    messageText?: string;
    contact?: ChatWidgetContactDto;
    visitor?: ChatWidgetVisitorDto;
    visitorKind?: "guest" | "client";
};

export const chatWidgetMessageApi = async (payload: PostChatWidgetMessageDto) => {
    return createAxiosApi()<{ ok: boolean; sessionId: string; messageId: string; createdAt: string }>({
        type: "post",
        url: "/chat-widget/message",
        body: payload,
    }).then((res) => res.data);
};

